import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EMessageChannel } from './message';
import { EModel } from './model';
export let EFollowupModel;
(function (EFollowupModel) {
  EFollowupModel["Activity"] = "activity";
  EFollowupModel["Appointment"] = "appointment";
  EFollowupModel["AppointmentType"] = "appointmentType";
  EFollowupModel["Availability"] = "availability";
  EFollowupModel["BillingTransaction"] = "billingTransaction";
  EFollowupModel["Broadcast"] = "broadcast";
  EFollowupModel["Campaign"] = "campaign";
  EFollowupModel["ChatActivity"] = "chatActivity";
  EFollowupModel["ChatActivityReason"] = "chatActivityReason";
  EFollowupModel["Diagnosis"] = "diagnosis";
  EFollowupModel["Estimate"] = "estimate";
  EFollowupModel["Facility"] = "facility";
  EFollowupModel["FaxDocument"] = "faxDocument";
  EFollowupModel["FeedbackResponse"] = "feedbackResponse";
  EFollowupModel["FileUpload"] = "fileUpload";
  EFollowupModel["Group"] = "group";
  EFollowupModel["Hl7message"] = "hl7message";
  EFollowupModel["Insurance"] = "insurance";
  EFollowupModel["Integrator"] = "integrator";
  EFollowupModel["Intent"] = "intent";
  EFollowupModel["LumabotFlow"] = "lumaBotFlow";
  EFollowupModel["LumabotFlowTemplate"] = "lumaBotFlowTemplate";
  EFollowupModel["Message"] = "message";
  EFollowupModel["MessageTemplate"] = "messageTemplate";
  EFollowupModel["MessageTemplatePartial"] = "messageTemplatePartial";
  EFollowupModel["Offer"] = "offer";
  EFollowupModel["OutboundNumber"] = "outboundNumber";
  EFollowupModel["Patient"] = "patient";
  EFollowupModel["PatientForm"] = "patientForm";
  EFollowupModel["PatientFormTemplate"] = "patientFormTemplate";
  EFollowupModel["PatientMessageTemplate"] = "patientMessageTemplate";
  EFollowupModel["Procedure"] = "procedure";
  EFollowupModel["Provider"] = "provider";
  EFollowupModel["Recall"] = "recall";
  EFollowupModel["Referral"] = "referral";
  EFollowupModel["Reminder"] = "reminder";
  EFollowupModel["Schedule"] = "schedule";
  EFollowupModel["Telehealth"] = "telehealth";
  EFollowupModel["User"] = "user";
  EFollowupModel["WaitingRoomPatient"] = "waitingRoomPatient";
  EFollowupModel["Waitlist"] = "waitlist";
  EFollowupModel["All"] = "all";
  EFollowupModel["None"] = "none";
  EFollowupModel["Invoke"] = "invoke";
})(EFollowupModel || (EFollowupModel = {}));
export let EFollowupOperation;
(function (EFollowupOperation) {
  EFollowupOperation["Created"] = "created";
  EFollowupOperation["Deleted"] = "deleted";
  EFollowupOperation["Updated"] = "updated";
  EFollowupOperation["All"] = "all";
})(EFollowupOperation || (EFollowupOperation = {}));
export let EFollowupAction; // Spark Navigator
(function (EFollowupAction) {
  EFollowupAction["SendMessage"] = "send-message";
  EFollowupAction["AlertStaff"] = "alert-staff";
  EFollowupAction["StartBot"] = "start-bot";
  EFollowupAction["HttpsWebhook"] = "https-webhook";
  EFollowupAction["ConfirmAppointment"] = "confirm-appointment";
  EFollowupAction["CancelAppointment"] = "cancel-appointment";
  EFollowupAction["ArriveAppointment"] = "arrive-appointment";
  EFollowupAction["CreateReferral"] = "create-referral";
  EFollowupAction["CancelReferral"] = "cancel-referral";
  EFollowupAction["OpenChat"] = "open-chat";
  EFollowupAction["CloseChat"] = "close-chat";
  EFollowupAction["InternalChat"] = "internal-chat";
  EFollowupAction["JoinWaitlist"] = "join-waitlist";
  EFollowupAction["LeaveWaitlist"] = "leave-waitlist";
  EFollowupAction["JoinWaitingRoom"] = "join-waiting-room";
  EFollowupAction["SendPhysicalMail"] = "send-physical-mail";
  EFollowupAction["CreatePatientInIntegrator"] = "create-patient-in-integrator";
  EFollowupAction["ExecuteJavaScript"] = "execute-javascript";
  EFollowupAction["AssignChat"] = "assign-chat";
  EFollowupAction["SendSlackMessage"] = "send-slack-message";
  EFollowupAction["SendTeamsMessage"] = "send-teams-message";
  EFollowupAction["CreateSalesforceRecord"] = "create-salesforce-record";
  EFollowupAction["Wait"] = "wait";
  EFollowupAction["If"] = "if";
  EFollowupAction["None"] = "none";
  EFollowupAction["SetContext"] = "set-context";
  EFollowupAction["ExecuteAssistantTool"] = "execute-assistant-tool";
  EFollowupAction["InvokeIntegratorApi"] = "invoke-integrator-api";
  EFollowupAction["InvokeRestApi"] = "invoke-rest-api";
  EFollowupAction["InvokeFhirApi"] = "invoke-fhir-api";
  EFollowupAction["InvokeNavigator"] = "invoke-navigator";
})(EFollowupAction || (EFollowupAction = {}));
export let EFollowupActionUnit;
(function (EFollowupActionUnit) {
  EFollowupActionUnit["Seconds"] = "seconds";
  EFollowupActionUnit["Minutes"] = "minutes";
  EFollowupActionUnit["Hours"] = "hours";
  EFollowupActionUnit["Days"] = "days";
})(EFollowupActionUnit || (EFollowupActionUnit = {}));
export let EFollowupActionAtAnchor;
(function (EFollowupActionAtAnchor) {
  EFollowupActionAtAnchor["Operation"] = "operation";
  EFollowupActionAtAnchor["ObjectDate"] = "object-date";
})(EFollowupActionAtAnchor || (EFollowupActionAtAnchor = {}));
export let EFollowupBot;
(function (EFollowupBot) {
  EFollowupBot["Followup"] = "bot:followup";
  EFollowupBot["Referral"] = "bot:referral";
  EFollowupBot["jenna"] = "bot:jenna";
})(EFollowupBot || (EFollowupBot = {}));
export let EFollowupForceCommunicationAs;
(function (EFollowupForceCommunicationAs) {
  EFollowupForceCommunicationAs["None"] = "none";
  EFollowupForceCommunicationAs["Sms"] = "sms";
  EFollowupForceCommunicationAs["Voice"] = "voice";
  EFollowupForceCommunicationAs["Email"] = "email";
  EFollowupForceCommunicationAs["Whatsapp"] = "whatsapp";
})(EFollowupForceCommunicationAs || (EFollowupForceCommunicationAs = {}));
export let EFollowupConfigurationAssignChatRef;
(function (EFollowupConfigurationAssignChatRef) {
  EFollowupConfigurationAssignChatRef["Group"] = "group";
  EFollowupConfigurationAssignChatRef["User"] = "user";
})(EFollowupConfigurationAssignChatRef || (EFollowupConfigurationAssignChatRef = {}));
export let EFollowupPriority;
(function (EFollowupPriority) {
  EFollowupPriority["RealTimeMessaging"] = "real-time-messaging";
  EFollowupPriority["Normal"] = "normal";
})(EFollowupPriority || (EFollowupPriority = {}));
export let EWeekDays;
(function (EWeekDays) {
  EWeekDays[EWeekDays["Monday"] = 1] = "Monday";
  EWeekDays[EWeekDays["Tuesday"] = 2] = "Tuesday";
  EWeekDays[EWeekDays["Wednesday"] = 3] = "Wednesday";
  EWeekDays[EWeekDays["Thursday"] = 4] = "Thursday";
  EWeekDays[EWeekDays["Friday"] = 5] = "Friday";
  EWeekDays[EWeekDays["Saturday"] = 6] = "Saturday";
  EWeekDays[EWeekDays["Sunday"] = 7] = "Sunday";
})(EWeekDays || (EWeekDays = {}));
export let EInvokeExternalApiType;
(function (EInvokeExternalApiType) {
  EInvokeExternalApiType["Integrator"] = "integrator";
  EInvokeExternalApiType["ThirdParty"] = "third-party";
  EInvokeExternalApiType["Fhir"] = "fhir";
})(EInvokeExternalApiType || (EInvokeExternalApiType = {}));
export const fieldsFollowup = _extends({}, fieldsIBaseModel, {
  action: {
    type: 'Option',
    values: EFollowupAction
  },
  actionAt: {
    type: 'Number'
  },
  actionAtAnchor: {
    type: 'Option',
    values: EFollowupActionAtAnchor
  },
  actionAtUnit: {
    type: 'Option',
    values: EFollowupActionUnit
  },
  anchorAtOperationPastEventsTolerance: {
    type: 'Number'
  },
  bot: {
    type: 'Option',
    values: EFollowupBot
  },
  configuration: {
    type: 'Object'
  },
  delay: {
    type: 'Number'
  },
  enabled: {
    type: 'Boolean'
  },
  executeJavaScript: {
    type: 'Text'
  },
  filters: {
    type: 'Object',
    array: true
  },
  forceCommunicationAs: {
    type: 'Option',
    values: EFollowupForceCommunicationAs
  },
  group: {
    type: 'Text'
  },
  joinWaitingRoomRoom: {
    type: 'ID',
    ref: EModel.WaitingRoom
  },
  model: {
    type: 'Option',
    values: EFollowupModel
  },
  openChatFacility: {
    type: 'ID',
    ref: EModel.Facility
  },
  operation: {
    type: 'Option',
    values: EFollowupOperation
  },
  rebuildDateRange: {
    type: 'Date'
  },
  secure: {
    type: 'Boolean'
  },
  sendMessageAutomaticallyHandleIrregularIntent: {
    type: 'Boolean'
  },
  sendMessageDayOfWeekRule: {
    type: 'Object'
  },
  sendMessageForceTimeHour: {
    type: 'Number'
  },
  sendMessageForceTimeMinute: {
    type: 'Number'
  },
  sendMessageShouldSkipReminderDeduping: {
    type: 'Boolean'
  },
  sendMessageSkipBlackoutRules: {
    type: 'Boolean'
  },
  sendMessageSkipDeliveryRules: {
    type: 'Boolean'
  },
  sendPhysicalMailFromAddressOverride: {
    type: 'Text'
  },
  sendPhysicalMailFrontTemplate: {
    type: 'Text'
  },
  sendPhysicalMailLobApiKey: {
    type: 'Text'
  },
  stats: {
    type: 'Object'
  },
  template: {
    type: 'Text'
  },
  title: {
    type: 'Text'
  },
  type: {
    type: 'Text'
  },
  user: {
    type: 'ID',
    ref: EModel.User
  },
  webhook: {
    type: 'Text'
  },
  webhookHeaders: {
    type: 'Object',
    array: true
  },
  webhookHmacSecret: {
    type: 'Text'
  },
  priority: {
    type: 'Option',
    values: EFollowupPriority
  },
  campaignChannelsOverride: {
    type: 'Option',
    values: EMessageChannel,
    array: true
  },
  ipWhitelist: {
    type: 'Text',
    array: true
  },
  createdBy: {
    type: 'ID',
    ref: EModel.User
  },
  updatedBy: {
    type: 'ID',
    ref: EModel.User
  },
  deletedBy: {
    type: 'ID',
    ref: EModel.User
  },
  deletedAt: {
    type: 'Date'
  },
  deleted: {
    type: 'Number'
  },
  invokeExternalApiType: {
    type: 'Option',
    values: EInvokeExternalApiType
  },
  followupWorkflow: {
    type: 'ID',
    ref: EModel.FollowupWorkflow
  }
});